/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import type { EditorModule } from "document-model";
import { lazy } from "react";

/** Document editor module for the "powerhouse/renown-user" document type */
export const RenownUserEditor: EditorModule = {
  Component: lazy(() => import("./editor.js")),
  documentTypes: ["powerhouse/renown-user"],
  config: {
    id: "renown-user-editor",
    name: "Renown User Editor",
  },
};
